import { Field } from "react-final-form";
import { formatters } from "common/FormUtils";
import TextField from "./TextField";

/**
 * Keys that would start a fractional or exponent value. The field only ever keeps whole numbers,
 * so swallowing these beats letting a decimal be typed and then silently disappear on blur.
 */
const FRACTIONAL_KEYS = [".", ",", "e", "E"];

export default function WholeNumberField({ input, onKeyDown, ...rest }) {
    const handleKeyDown = (e) => {
        if (FRACTIONAL_KEYS.includes(e.key)) {
            e.preventDefault();
            return;
        }

        if (onKeyDown) onKeyDown(e);
    };

    return <Field {...input} {...rest} format={formatters.formatInt} formatOnBlur type="number" onKeyDown={handleKeyDown} component={TextField} />;
}
